export const data = [
    {
        to:'/',
        text:'Home',
        id: 'home',
    },
    {
        to:'/chronik',
        text:'Chronik',
    },
    {
        to:'/galerie',
        text:'Galerie',
    },/*
    {
        to:'/hoerprobe',
        text: 'Hörprobe',
    },*/
    {
        to:'kontakt',
        text:'Kontakt',
    },
    {
        to:'/termine',
        text:'Termine',
    },

];